export enum TrackingStatus {
    loaded = "loaded",
    cargado = "cargado",
    transito = "transito",
    reparto = "reparto",
    entregado = "entregado",
    none = "none"
}
